export class Role {
    'id';
    'name';
    'isBuiltInRole';
    'permissionGrants';
    'accessConditions';
    'restoreDestinationLimits';
    'backupPoliciesLimits';
    'scopes';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "isBuiltInRole",
            "baseName": "isBuiltInRole",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "permissionGrants",
            "baseName": "permissionGrants",
            "type": "Array<PermissionGrant>",
            "format": ""
        },
        {
            "name": "accessConditions",
            "baseName": "accessConditions",
            "type": "Array<AccessCondition>",
            "format": ""
        },
        {
            "name": "restoreDestinationLimits",
            "baseName": "restoreDestinationLimits",
            "type": "RestoreDestinationLimits",
            "format": ""
        },
        {
            "name": "backupPoliciesLimits",
            "baseName": "backupPoliciesLimits",
            "type": "BackupPoliciesLimits",
            "format": ""
        },
        {
            "name": "scopes",
            "baseName": "scopes",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return Role.attributeTypeMap;
    }
    constructor() {
    }
}
